<script setup>
import AdvancePaymentStatus from "@/components/SpecialComponents/AdvancePaymentStatus.vue";
import AdvancePaymentPrice from "@/components/SpecialComponents/AdvancePaymentPrice.vue";
import { defineProps, defineEmits } from 'vue';
import ButtonSuccess from "@/components/Buttons/ButtonSuccess.vue";
import ButtonPrimary from "@/components/Buttons/ButtonPrimary.vue";

/**
 * @typedef {Object} VisitItem
 * @property {string} id
 * @property {string} date
 * @property {string} time
 * @property {Object} payment
 */
defineProps(['item', 'areVisitsClosed', 'cancelVisit']);
defineEmits(['cancelVisit']);
</script>

<template>
  <div class="visit-card">
    <div class="visit-card-body">
      <div class="visit-card-meta">
        <span class="visit-day">Data wizyty: {{ item.date.split('T')[0] }}, <br> {{ item.time }}</span>
        <span class="visit-advance-status" v-if="item.payment?.order">
          <AdvancePaymentPrice :price="item.payment.order.price"/>
          <AdvancePaymentStatus :key="item.id" :payment-status="item.payment.status" :visit-status="item.status" :payment-id="item.payment.id" :calendar-item-id="item.id" />
        </span>
      </div>
      <span class="visit-info">{{ item.visit_info }}</span>
      <ButtonSuccess @click="() => $router.push({path: '/profile/visits', query: {serviceID: item.service_id}})">Szczegóły usługi</ButtonSuccess>
      <ButtonPrimary @click="$emit('cancelVisit', item.id)" v-if="item.status === 'open'">Anuluj wizytę</ButtonPrimary>
    </div>
  </div>
</template>

<style scoped lang="scss">
.visit-card {
  display: flex;
  gap: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  transition: box-shadow 0.2s, border-color 0.2s;
  margin-bottom: 16px;
}
.visit-card:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  border-color: #10b981;
}
.visit-card-body {
  flex: 1;
  padding: 14px 16px 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.visit-card-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.visit-day {
  background-color: #d1fae5;
  color: #065f46;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 10px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  display: flex;
  align-items: center;
}
.visit-advance-status {
  color: #9a3412;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 10px;
  border-radius: 6px;
}
.visit-info {
  font-size: 1.2rem;
  font-weight: 500;
  padding: 6px;
}
</style>